import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { GeneralSetups as GeneralSetupsComponent } from "ui/organizms/Setup";

const GeneralSetups = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Setup | General Setups'
    >
        <GeneralSetupsComponent />
    </Screen>

);

export default memo(GeneralSetups);